import HideComponentWrapper from "./HideComponentWrapper";
export default HideComponentWrapper;
